import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import Prize from "@jumbo/Dashboards/PointShop/Prize";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.pointShop"} />, link: "/pointShop" },
  { label: <IntlMessages id={"pages.createPrize"} />, isActive: true },
];

const CreatePrize = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.createPrize" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <Prize />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreatePrize;
